import { TFunction } from "i18next";

import { DocumentCommitteeEmployee } from "../../../../models/Request";
import { FormatUtils } from "../../../../utils";

export const formatDateRange = (
  dateFrom?: string | Date,
  dateTo?: string | Date
) => {
  return `${FormatUtils.formatDate(dateFrom)} - ${FormatUtils.formatDate(
    dateTo
  )}`;
};

export const getOIBFromName = (name: string): string => {
  return name.split(",")[0];
};

export const formatDocumentCommitteeEmployee = (
  employee: DocumentCommitteeEmployee,
  t: TFunction
) => {
  const parts = [
    employee.oib,
    employee.fullName,
    getOpinionText(employee, t),
    getActiveToText(employee, t),
  ].filter(Boolean);

  return parts.join(", ");
};

const getOpinionText = (employee: DocumentCommitteeEmployee, t: TFunction) => {
  const decision = employee.decision
    ? t("common.yes").toUpperCase()
    : t("common.no").toUpperCase();

  return `${t("committeeDecision.inputtedDecision")}: ${decision}`;
};

const getActiveToText = (employee: DocumentCommitteeEmployee, t: TFunction) => {
  if (!employee.deactivationDate) return "";

  return `${t("common.expertCommission.activeTo")}: ${FormatUtils.formatDate(
    employee.deactivationDate
  )}`;
};
